import { systemType } from '@/constants';
import wangeditor from 'wangeditor';
import AlertMenu from '@/util/alertMenu';
import { useUserStoreHook } from '@/store/user';
var useStore = useUserStoreHook();
export default {
  props: ['type', 'detail'],
  data() {
    return {
      ruleForm: {},
      edihtml: '',
      title: '',
      wangeditorLoading: Boolean,
      editor: null,
      editorContent: ''
    };
  },
  created() {},
  watch: {
    detail(val) {
      // console.log(val);
      this.edihtml = val;
      this.editorContent.txt.html(this.detail);
    }
  },
  methods: {},
  mounted() {
    // console.log(this.type);
    // console.log(this.detail);
    this.editorContent = new wangeditor(this.$refs.editorElem);
    this.editorContent.menus.extend('alertMenu', AlertMenu); // 配置扩展菜单
    this.editorContent.config.menus = this.editorContent.config.menus.concat('alertMenu');
    this.editorContent.config.showFullScreen = false;
    this.editorContent.config.showLinkImg = false; //   禁止上传网络图片
    this.editorContent.config.uploadImgServer = process.env.VUE_APP_BASE_URL + '/api/file/add_file';
    this.editorContent.config.uploadParams = {
      user_id: useStore.info.id // 用户id
    };
    this.editorContent.config.uploadFileName = 'file'; // 后端接受上传文件的参数名
    this.editorContent.config.uploadImgHeaders = {
      token: 'Bearer ' + localStorage.getItem('token_blk'),
      'system-type': systemType
    };
    this.editorContent.config.uploadImgHooks = {
      before: function before(xhr, editor, files) {
        if (files.length != 0) {
          this.wangeditorLoading = true;
        }
      },
      success: function success(xhr, editor, result) {
        // console.log(result);
        // console.log('success')
      },
      fail: function fail(xhr, editor, result) {
        // console.log('fail')
      },
      error: function error(xhr, editor) {
        console.log('error');
      },
      timeout: function timeout(xhr, editor) {
        console.log('timeout');
      },
      customInsert: function customInsert(insertImg, result, editor) {
        this.wangeditorLoading = false;
        // console.log('customInsert上传了图片：', result.data.file_url);
        insertImg(result.data.file_url);
      }
    };
    this.editorContent.config.onchange = html => {
      // console.log(html);
      this.edihtml = html;
      this.$emit('change', this.edihtml); // 将内容同步到父组件中
    };
    this.editorContent.create();
    this.editorContent.txt.html(this.detail);
    // console.log(store.state.userInfo);
    // $(".w-e-text-container").css("height", "600px");
  }
};